export const DOCUMENTS_ARR = {
  IVA: {
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  KLG: {
    expired: null,
    inProcess: 23,
    current: 23,
  },
  KAZ: {
    expired: 47,
    inProcess: null,
    current: 23,
  },
  KLI: {
    expired: null,
    inProcess: null,
    current: 59,
  },
  NOV: {
    expired: null,
    inProcess: 23,
    current: 23,
  },
  OMS: {
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  SAR: {
    expired: 47,
    inProcess: null,
    current: 23,
  },
  UFA: {
    expired: null,
    inProcess: 23,
    current: 23,
  },
  ULY: {
    expired: 47,
    inProcess: null,
    current: 23,
  },
  VLA: {
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  VOL: {
    expired: null,
    inProcess: 23,
    current: 23,
  },
  MKAZ: {
    expired: 47,
    inProcess: null,
    current: 23,
  },
  MOMS: {
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  MSAR: {
    expired: null,
    inProcess: 23,
    current: 23,
  },
};

export const ACTIONS_ARR = {
  IVA: {
    notStarted: 5,
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  KLG: {
    notStarted: null,
    expired: null,
    inProcess: 23,
    current: 23,
  },
  KAZ: {
    notStarted: null,
    expired: 47,
    inProcess: null,
    current: 23,
  },
  KLI: {
    notStarted: 5,
    expired: null,
    inProcess: null,
    current: 59,
  },
  NOV: {
    notStarted: null,
    expired: null,
    inProcess: 23,
    current: 23,
  },
  OMS: {
    notStarted: 5,
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  SAR: {
    notStarted: null,
    expired: 47,
    inProcess: null,
    current: 23,
  },
  UFA: {
    notStarted: null,
    expired: null,
    inProcess: 23,
    current: 23,
  },
  ULY: {
    notStarted: null,
    expired: 47,
    inProcess: null,
    current: 23,
  },
  VLA: {
    notStarted: 5,
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  VOL: {
    notStarted: null,
    expired: null,
    inProcess: 23,
    current: 23,
  },
  MKAZ: {
    notStarted: null,
    expired: 47,
    inProcess: null,
    current: 23,
  },
  MOMS: {
    notStarted: 5,
    expired: 39,
    inProcess: 23,
    current: 23,
  },
  MSAR: {
    notStarted: null,
    expired: null,
    inProcess: 23,
    current: 23,
  },
};

export const LabelsLicense = [
  {
    label: 'Действующий',
    color: '#22AD5C',
    type: 'current',
  },
  {
    label: 'В процессе',
    color: '#F2A900',
    type: 'inProcess',
  },
  {
    label: 'Просрочен',
    color: '#BA0C2F',
    type: 'expired',
  },
  {
    label: 'В архиве',
    color: '#DEE2E6',
    type: 'archived',
  },
];

export const LabelsPrescription = [
  {
    label: 'Выполнено',
    color: '#22AD5C',
    type: 'completed',
  },
  {
    label: 'В процессе',
    color: '#F2A900',
    type: 'inProcess',
  },
  {
    label: 'Просрочено',
    color: '#BA0C2F',
    type: 'expired',
  },
 
];

export const LabelsActions = [
  {
    label: 'Закрыто и отменено',
    color: '#22AD5C',
    type: 'current',
  },
  {
    label: 'В процессе',
    color: '#F2A900',
    type: 'inProcess',
  },
  {
    label: 'Просрочено',
    color: '#BA0C2F',
    type: 'expired',
  },
  {
    label: 'Не начато',
    color: '#DEE2E6',
    type: 'notStarted',
  },
];
